export default __webpack_public_path__ + "static/media/rezaHajipour.cc50f5cc.png";